export default __webpack_public_path__ + "static/media/pilih.b01c417e.svg";